export default "__VITE_ASSET__UcTzBa92__"